import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import {
  AccreditationDetails,
  mapToScopeCertificateForm,
  ScopeCertificateDates,
  ScopeCertificateDetails,
  ScopeCertificateForm,
  scopeCertificateFormToMap,
  StandardDetails,
} from "../../../sc-models/scope-certificate-details-dto";
import ScopeCertificateDetailsForm from "./scope-certificate-details-form";
import ScopeCertificateDatesForm from "./scope-certificate-dates-form";
import AccreditationDetailsForm from "./accreditation-details-form";
import { FooterContainer } from "../../../../../shared/components/modals/custom-popup";
import StandardDetailsForm from "./standard-details-form";
import { useApi } from "../../../../../shared/hooks/useApi";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { useNavigate, useParams } from "react-router-dom";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import useNotification from "../../../../../shared/hooks/useNotification";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { useScStore } from "../../../../../store/scStandard.store";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { TCAppConfig } from "../../../../../shared/app-configs/tc-app-configs";
import { isAdmin } from "../../../../../shared/utils/admin-utils";

const initScopeCertificateDetails: ScopeCertificateDetails = {
  scopeCertificateNo: "",
  brandName: [],
  gotsSCNo: "",
  scLegacyNo: [],
  scCBAuditorId: [],
  scStandardProgram: "",
  scStatus: "",
  scWithdrawalReason: "",
  scSuspensionReason: "",
  scCBLicensingCode: "",
  scVersionNo: "",
  ccsFlag:""
  // globalComment: "",
};

const initScopeCertificateDates: ScopeCertificateDates = {
  scValidUntil: "",
  scDateOfIssue: "",
  scPlaceOfIssue: "",
  scLastUpdated: "",
  scLastAuditDate: "",
  scTransferAuditDate: "",
  scExtendedUntil: "",
  scLastAuditStart: "",
};

const initAccreditationDetails: AccreditationDetails = {
  scScopeStipulations: "",
  accreditationBody: "",
  accreditationNo: "",
  inspectionBody: "",
};

const initScopeCertificateForm: ScopeCertificateForm = {
  scopeCertificateDetails: initScopeCertificateDetails,
  standardDetails: [],
  scopeCertificateDates: initScopeCertificateDates,
  accreditationDetails: initAccreditationDetails,
};

interface ScopeCertificateComponentProps {
  onNextTab: () => Promise<void>;
}

const ScopeCertificateComponent: React.FC<ScopeCertificateComponentProps> = ({ onNextTab }) => {

  const isViewMode = isAdmin(); // Admin users have view-only access
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [data, setData] = useState<ScopeCertificateForm[]>([]);
  const [scopeCertificateData, setScopeCertificateData] =
    useState<ScopeCertificateForm>(initScopeCertificateForm);
  const { executeGet, executePost, loading } = useApi();
  const scopeDetailsRef = useRef<any>(null);
  const standardDetailsRef = useRef<any>(null);
  const certificateDatesRef = useRef<any>(null);
  const accreditationDetailsRef = useRef<any>(null);
  const { isRestrictPopUpSave, cbLicensingCode } = useTransactionCertificateStore();
  const navigate = useNavigate();
  const { notify } = useNotification()
  const { formtype, SC_ID } = useParams();
  const { editSCInfo, setScStandards } = useScStore();
  const hasSubmitSC: boolean = formtype === 'submited-sc';
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpBtnName, setPopUpBtnName] = useState("");
  const [existingSCData, setExistingSCData] = useState<any>(null);

  const { setEditSCInfo } = useScStore();

  const fetchScopeCerificateDetails = async () => {
    const result = await executeGet(API_ROUTES.GET_SC_DETAILS, { scId: SC_ID });
    const data = mapToScopeCertificateForm(result?.data);
    const standards = result?.data?.scStandardDetails?.map(
      (item: any) => item.scStandard
    ) || [];

    console.log("Standards from API:", standards); // For debugging
    setScStandards(standards);
    setScopeCertificateData(data);
    setExistingSCData(data);
  };
  useEffect(() => {

    if (SC_ID) fetchScopeCerificateDetails();
  }, []);

  const toggleDrawer = () => {
    setActiveStep(0);
    setDrawerOpen((prev) => !prev);
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setScopeCertificateData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  const formRefs = [scopeDetailsRef, standardDetailsRef, certificateDatesRef, accreditationDetailsRef]
  const handleNext = async () => {
    if (isViewMode) {
      setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
      return;
    }
    if (formRefs[activeStep]?.current) {
      const errors = await formRefs[activeStep].current.validateForm();
      await formRefs[activeStep].current.submitForm();
      if (Object.keys(errors).length === 0) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      } else {
        notify('Please Enter the Required Values', 'error');
      }
    }
    else {
      if (activeStep === 1) {
        if (scopeCertificateData.standardDetails.length > 0) {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify('Please Enter the Required Values', 'error');
          return;
        }
      }
    }
  };
  const handleFinish = async () => {
    Utills.cl("Form Values:", formRefs[activeStep]?.current?.values);

    if (isViewMode) {
      await onNextTab();
      navigate(`/sc/${formtype}/certified-organization-details/${SC_ID}`);
      return;
    }

    if (formRefs[activeStep]?.current) {
      try {
        const errors = await formRefs[activeStep].current.validateForm();
        await formRefs[activeStep].current.submitForm();
        if (Object.keys(errors).length === 0) {
          // Wait for the form submission to complete
          await formRefs[activeStep].current.submitForm();

          // Ensure scopeCertificateData gets updated through form submission
          const updatedScopeCertificateData = {
            ...scopeCertificateData,
            accreditationDetails: {
              scScopeStipulations: formRefs[activeStep].current.values.scScopeStipulations || "",
              accreditationBody: formRefs[activeStep].current.values.accreditationBody || "",
              accreditationNo: formRefs[activeStep].current.values.accreditationNo || "",
              inspectionBody: formRefs[activeStep].current.values.inspectionBody || "",
            },
          };

          // Call the post function with updated data
          await postScopeCertificateDetails(updatedScopeCertificateData);
        } else {
          notify('Please Enter the Required Values', 'error');
        }
      } catch (error) {
        console.error("Error during form submission or validation:", error);
        notify('An error occurred during form submission', 'error');
      }
    }
  };


  const postScopeCertificateDetails = async (updatedScopeCertificateData: ScopeCertificateForm) => {
    try {
      const payload = scopeCertificateFormToMap(updatedScopeCertificateData, SC_ID, cbLicensingCode);
      const queryParams = new URLSearchParams();

      if (SC_ID) {
        queryParams.set("isNewlyCreated", "No");
        if (updatedScopeCertificateData?.scopeCertificateDetails?.scopeCertificateNo != existingSCData?.scopeCertificateDetails?.scopeCertificateNo || updatedScopeCertificateData?.scopeCertificateDetails?.scVersionNo != existingSCData?.scopeCertificateDetails?.scVersionNo) {
          queryParams.set("oldScNo", existingSCData.scopeCertificateDetails.scopeCertificateNo);
          queryParams.set("oldScVersionNo", existingSCData.scopeCertificateDetails.scVersionNo);
        }
      }
      else {
        queryParams.set("isNewlyCreated", "Yes");
      }
      const finalUrl = `${API_ROUTES.POST_SC_DETAILS}?${queryParams}`;
      const res = await executePost(finalUrl, payload);

      if (res?.status === 200) {
        Utills.cl(res.data.scId);
        notify("Saved Succesfully", "success");
        await onNextTab();
        navigate(
          `/sc/${formtype}/certified-organization-details/${res.data.scId}`
        );
      } else {
        notify('Failed to save certificate details', 'error');
      }
    } catch (error) {
      console.error("Error posting scope certificate details:", error);
      notify('An error occurred while saving the certificate details', 'error');
    }
  };

  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));


  const steps = [
    {
      label: "Scope Certificate Details",
      content: (
        <ScopeCertificateDetailsForm
          formRef={scopeDetailsRef}
          detailsData={scopeCertificateData.scopeCertificateDetails}
          setDetailsData={(data) =>
            handleDataUpdate("scopeCertificateDetails", data)
          }
          // standardData={scopeCertificateData.standardDetails}
          // setStandardsData = {(data:any) => handleDataUpdate("standardDetails", data)}
          SC_ID={SC_ID}
        />
      ),
    },
    {
      label: "Standard Details",
      content: (
        <StandardDetailsForm
          ccsFlag={scopeCertificateData.scopeCertificateDetails?.ccsFlag}
          standardData={scopeCertificateData.standardDetails}
          setStandardData={(data) => handleDataUpdate("standardDetails", data)}
        />
      ),
    },
    {
      label: "Certificate Dates",
      content: (
        <ScopeCertificateDatesForm
          formRef={certificateDatesRef}
          datesData={scopeCertificateData.scopeCertificateDates}
          setDatesData={(data) =>
            handleDataUpdate("scopeCertificateDates", data)
          }
        />
      ),
    },
    {
      label: "Accreditation Details",
      content: (
        <AccreditationDetailsForm
          formRef={accreditationDetailsRef}
          accreditationData={scopeCertificateData.accreditationDetails}
          setAccreditationData={(data) =>
            handleDataUpdate("accreditationDetails", data)
          }
        />
      ),
    },
  ];

  // Function to navigate to next tab
  const handleNavigateToNextTab = () => {
    navigate(`/sc/${formtype}/certified-organization-details/${SC_ID}`);
  };

  const actions: ActionButtonConfig[] = [
   
    ...(
      // activeStep === 0 &&
       editSCInfo?.isParentStatus === true && formtype!=='create-sc' && !isViewMode ? [
      {
        label: "Cancel Amendment",
        onClick: () => {
          setDialogOpen(true);
          setPopUpTitle("Cancel Amendment");
          setPopUpMessage("Are you sure you want to cancel this amendment?");
          setPopUpBtnName("Confirm");
        },
        variant: "contained" as const,
        color: "secondary" as const,
      }
    ] : []),
    {
      label:"Home",
      onClick: ()=>{
        navigate('/sc-dashboard');
      },
      variant: "contained",
      color: "default",

    },
    ...(activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as const,
      color: "default" as const,
      disabled: activeStep === 0,
    }]:[]),
    {
      label: activeStep === steps.length - 1
        ? (hasSubmitSC || isViewMode)
          ? "Next"
          : "Save & Next"
        : "Next",
      onClick: activeStep === steps.length - 1
        ? (hasSubmitSC || isViewMode)
          ? handleNavigateToNextTab
          : handleFinish
        : handleNext,
      disabled:activeStep==1 && isRestrictPopUpSave,
      variant: "contained",
      color: "primary",
    },
  ];

  const handleCancelSave = () => {
    setDialogOpen(false);
  };

  const handleCancelAmendment = async () => {
    try {
      await executePost(
        API_ROUTES.GET_SC_CANCEL_AMEND,
        { scId: SC_ID, scCbLicensingCode: cbLicensingCode }
      );
      notify("Cancelled Amendment Successfully", "success");
    } catch (err) {
      console.error("Failed to cancel amendment", err);
    }
    navigate(`/sc-dashboard`);
  };

  return (
    <>
      {" "}
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <CustomStepper
            steps={steps}
            activeStep={activeStep}
            onStepChange={(step) => setActiveStep(step)}
          />

          <div style={{ marginTop: "3rem" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              {actions.map((action, index) => (
                <StyledButton
                  key={index}
                  onClick={action.onClick}
                  variant={action.variant || "text"}
                  //   color={action.color || 'primary'}
                  disabled={action.disabled}
                >
                  {action.label}
                </StyledButton>
              ))}
            </Box>
          </div>
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleCancelAmendment}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default ScopeCertificateComponent;
